module.exports = __webpack_public_path__ + "static/media/vip2.5219057b.png";